export const handleSignUpAttempt = async(checkOutURL) => {
    console.log("TRYING SIGNUP");
    let name = document.getElementById("name-input").value;
    let email = document.getElementById("email-input").value;
    let password = document.getElementById("password-input").value;

    let endpointUrl = process.env.REACT_APP_BACKEND_URL + "/signup";

    try {
      const response = await fetch(endpointUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({"name":name, "email" : email, "password" : password}),
      });

      const data = await response.json();
      console.log(response);
   
      if (response.ok) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'signup',
        }); 
        return { success: true, auth_code: data.auth_code };
      } else {
        return { success: false, errorMessage: data.message };
      }
    } catch (error) {
      return { success: false, errorMessage: 'Server error. Please try again later.' };
    }
  };